<template>
  <SeoBlogArticle :content="$t('seoArticleOQueEUtm')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleOQueEUtm',
  components: { SeoBlogArticle },
}
</script>
